export const DEPARTMENTS = [
  // General & Primary Care
  "General Medicine",
  "Family Medicine",
  "Emergency Medicine",

  // Surgical
  "General Surgery",
  "Orthopedics",
  "Neurosurgery",
  "Cardiothoracic Surgery",
  "Plastic & Reconstructive Surgery",
  "Urology",

  // Medical Specialties
  "Cardiology",
  "Dermatology",
  "Endocrinology",
  "Gastroenterology",
  "Hematology",
  "Nephrology",
  "Neurology",
  "Oncology",
  "Pulmonology",
  "Rheumatology",

  // Women & Children
  "Gynecology",
  "Obstetrics",
  "Pediatrics",
  "Neonatology",

  // Sensory & Dental
  "ENT",
  "Ophthalmology",
  "Dentistry",
  "Orthodontics",

  // Mental Health
  "Psychiatry",
  "Psychology",

  // Allied & AYUSH
  "Physiotherapy",
  "Ayurveda",
  "Homeopathy",
  "Naturopathy",
  "Yoga & Wellness",

  // Diagnostics / Support
  "Radiology",
  "Pathology",
  "Anesthesiology",
  "Nutrition & Dietetics",
];
